<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xx"></a><a id="page_xxi"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<p class="Bodyflush">Abbreviations in this English translation follow those in the <i>SBL Handbook of Style</i>, 2nd ed. (Atlanta: SBL Press, 2014), supplemented by Siegfried M. Schwertner, <i>Internationales Abkürzungsverzeichnis für Theologie und Grenzgebiete</i>, 3rd ed. (Berlin: de Gruyter, 2014).</p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td class="td">AB</td>
<td class="td">Anchor Bible</td>
</tr>
<tr>
<td class="td"><i>ABR</i></td>
<td class="td"><i>Australian Biblical Review</i></td>
</tr>
<tr>
<td class="td">AGJU</td>
<td class="td">Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</td>
</tr>
<tr>
<td class="td">AnBib</td>
<td class="td">Analecta Biblica</td>
</tr>
<tr>
<td class="td"><i>ANRW</i></td>
<td class="td"><i>Aufstieg und Niedergang der römischen Welt</i></td>
</tr>
<tr>
<td class="td">ATANT</td>
<td class="td">Abhandlungen zur Theologie des Alten und Neuen Testaments</td>
</tr>
<tr>
<td class="td"><i>AUSS</i></td>
<td class="td"><i>Andrews University Seminary Studies</i></td>
</tr>
<tr>
<td class="td"><i>BBR</i></td>
<td class="td"><i>Bulletin for Biblical Research</i></td>
</tr>
<tr>
<td class="td">BETL</td>
<td class="td">Bibliotheca Ephemeridum Theologicarum Lovaniensium</td>
</tr>
<tr>
<td class="td">BEvT</td>
<td class="td">Beiträge zur evangelischen Theologie</td>
</tr>
<tr>
<td class="td"><i>Bib</i></td>
<td class="td"><i>Biblica</i></td>
</tr>
<tr>
<td class="td"><i>BibInt</i></td>
<td class="td"><i>Biblical Interpretation</i></td>
</tr>
<tr>
<td class="td">BibInt</td>
<td class="td">Biblical Interpretation Series</td>
</tr>
<tr>
<td class="td"><i>BiHe</i></td>
<td class="td"><i>Bibel heute</i></td>
</tr>
<tr>
<td class="td"><i>BK</i></td>
<td class="td"><i>Bibel und Kirche</i></td>
</tr>
<tr>
<td class="td"><i>BL</i></td>
<td class="td"><i>Bibel und Liturgie</i></td>
</tr>
<tr>
<td class="td"><i>BN</i></td>
<td class="td"><i>Biblische Notizen</i></td>
</tr>
<tr>
<td class="td">BNTC</td>
<td class="td">Black’s New Testament Commentary</td>
</tr>
<tr>
<td class="td"><i>BT</i></td>
<td class="td"><i>The Bible Translator</i></td>
</tr>
<tr>
<td class="td"><i>BTB</i></td>
<td class="td"><i>Biblical Theology Bulletin</i></td>
</tr>
<tr>
<td class="td">BThSt</td>
<td class="td">Biblisch-theologische Studien</td>
</tr>
<tr>
<td class="td"><a id="page_xxii">BTS</a></td>
<td class="td">Biblical Tools and Studies</td>
</tr>
<tr>
<td class="td"><i>BTZ</i></td>
<td class="td"><i>Berliner Theologische Zeitschrift</i></td>
</tr>
<tr>
<td class="td">BWANT</td>
<td class="td">Beiträge zur Wissenschaft vom Alten und Neuen Testament</td>
</tr>
<tr>
<td class="td"><i>BZ</i></td>
<td class="td"><i>Biblische Zeitschrift</i></td>
</tr>
<tr>
<td class="td">BZNW</td>
<td class="td">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</td>
</tr>
<tr>
<td class="td"><i>CBQ</i></td>
<td class="td"><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td class="td">CBRA</td>
<td class="td">Collectanea Biblica et religiosa antiqua</td>
</tr>
<tr>
<td class="td"><i>Colloq</i></td>
<td class="td"><i>Colloquium</i></td>
</tr>
<tr>
<td class="td">ConBNT</td>
<td class="td">Coniectanea Biblica: New Testament Series</td>
</tr>
<tr>
<td class="td"><i>Conc(D)</i></td>
<td class="td"><i>Concilium (Deutsch)</i></td>
</tr>
<tr>
<td class="td"><i>CurBR</i></td>
<td class="td"><i>Currents in Biblical Research</i></td>
</tr>
<tr>
<td class="td"><i>CurBS</i></td>
<td class="td"><i>Currents in Research: Biblical Studies</i></td>
</tr>
<tr>
<td class="td"><i>CV</i></td>
<td class="td"><i>Communio Viatorum</i></td>
</tr>
<tr>
<td class="td"><i>EC</i></td>
<td class="td"><i>Early Christianity</i></td>
</tr>
<tr>
<td class="td">EKKNT</td>
<td class="td">Evangelisch-katholischer Kommentar zum Neuen Testament</td>
</tr>
<tr>
<td class="td">ESt</td>
<td class="td">Eichstätter Studien</td>
</tr>
<tr>
<td class="td"><i>ETL</i></td>
<td class="td"><i>Ephemerides Theologicae Lovanienses</i></td>
</tr>
<tr>
<td class="td">ETS</td>
<td class="td">Erfurter theologische Studien</td>
</tr>
<tr>
<td class="td"><i>EvQ</i></td>
<td class="td"><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td class="td"><i>EvT</i></td>
<td class="td"><i>Evangelische Theologie</i></td>
</tr>
<tr>
<td class="td"><i>ExpTim</i></td>
<td class="td"><i>Expository Times</i></td>
</tr>
<tr>
<td class="td">FC</td>
<td class="td">Fontes Christiani</td>
</tr>
<tr>
<td class="td">FRLANT</td>
<td class="td">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</td>
</tr>
<tr>
<td class="td">GSLNT</td>
<td class="td">Geistliche Schriftlesung: Erläuterungen zum Neuen Testament für die Geistliche Lesung</td>
</tr>
<tr>
<td class="td"><i>GuL</i></td>
<td class="td"><i>Geist und Leben</i></td>
</tr>
<tr>
<td class="td"><i>HBS</i></td>
<td class="td"><i>Herders Biblische Studien</i></td>
</tr>
<tr>
<td class="td"><i>HeyJ</i></td>
<td class="td"><i>Heythrop Journal</i></td>
</tr>
<tr>
<td class="td">HNT</td>
<td class="td">Handbuch zum Neuen Testament</td>
</tr>
<tr>
<td class="td">HThKNT</td>
<td class="td">Herders theologischer Kommentar zum Neuen Testament</td>
</tr>
<tr>
<td class="td"><i>HTR</i></td>
<td class="td"><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td class="td">HTS</td>
<td class="td">Hervormde theologiese studies / Theological Studies</td>
</tr>
<tr>
<td class="td"><i>IBS</i></td>
<td class="td"><i>Irish Biblical Studies</i></td>
</tr>
<tr>
<td class="td"><i>IKZ</i></td>
<td class="td"><i>Internationale kirchliche Zeitschrift</i></td>
</tr>
<tr>
<td class="td"><i>Int</i></td>
<td class="td"><i>Interpretation</i></td>
</tr>
<tr>
<td class="td"><i>JAAR</i></td>
<td class="td"><i>Journal of the American Academy of Religion</i></td>
</tr>
<tr>
<td class="td">JBTh</td>
<td class="td">Jahrbuch für biblische Theologie</td>
</tr>
<tr>
<td class="td"><i>JETS</i></td>
<td class="td"><i>Journal of the Evangelical Theological Society</i></td>
</tr>
<tr>
<td class="td"><i><a id="page_xxiii">JJS</a></i></td>
<td class="td"><i>Journal of Jewish Studies</i></td>
</tr>
<tr>
<td class="td"><i>JR</i></td>
<td class="td"><i>Journal of Religion</i></td>
</tr>
<tr>
<td class="td"><i>JSHJ</i></td>
<td class="td"><i>Journal for the Study of the Historical Jesus</i></td>
</tr>
<tr>
<td class="td">JSHRZ</td>
<td class="td">Jüdische Schriften aus hellenistisch-römischer Zeit</td>
</tr>
<tr>
<td class="td"><i>JSNT</i></td>
<td class="td"><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td class="td">JSNTSup</td>
<td class="td">Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td class="td">JSPSup</td>
<td class="td">Journal for the Study of the Pseudepigrapha Supplement Series</td>
</tr>
<tr>
<td class="td"><i>JTS</i></td>
<td class="td"><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td class="td"><i>Klio</i></td>
<td class="td"><i>Klio: Beiträge zur Alten Geschichte</i></td>
</tr>
<tr>
<td class="td"><i>LB</i></td>
<td class="td"><i>Linguistica Biblica</i></td>
</tr>
<tr>
<td class="td">LNTS</td>
<td class="td">Library of New Testament Studies</td>
</tr>
<tr>
<td class="td"><i>LTJ</i></td>
<td class="td"><i>Lutheran Theological Journal</i></td>
</tr>
<tr>
<td class="td"><i>MTZ</i></td>
<td class="td"><i>Münchener theologische Zeitschrift</i></td>
</tr>
<tr>
<td class="td">NEchtB</td>
<td class="td">Neue Echter Bibel</td>
</tr>
<tr>
<td class="td"><i>Neot</i></td>
<td class="td"><i>Neotestamentica</i></td>
</tr>
<tr>
<td class="td">NICNT</td>
<td class="td">New International Commentary on the New Testament</td>
</tr>
<tr>
<td class="td">NIGTC</td>
<td class="td">New International Greek Testament Commentary</td>
</tr>
<tr>
<td class="td"><i>NovT</i></td>
<td class="td"><i>Novum Testamentum</i></td>
</tr>
<tr>
<td class="td">NovTSup</td>
<td class="td">Supplements to Novum Testamentum</td>
</tr>
<tr>
<td class="td">NRSV</td>
<td class="td">New Revised Standard Version</td>
</tr>
<tr>
<td class="td">NTD</td>
<td class="td">Das Neue Testament Deutsch</td>
</tr>
<tr>
<td class="td">NTDSup</td>
<td class="td">Das Neue Testament Deutsch Supplement Series</td>
</tr>
<tr>
<td class="td">NTOA</td>
<td class="td">Novum Testamentum et Orbis Antiquus</td>
</tr>
<tr>
<td class="td"><i>NTS</i></td>
<td class="td"><i>New Testament Studies</i></td>
</tr>
<tr>
<td class="td">NTTS</td>
<td class="td">New Testament Tools and Studies</td>
</tr>
<tr>
<td class="td"><i>OHJSA</i></td>
<td class="td"><i>Oral History Journal of South Africa</i></td>
</tr>
<tr>
<td class="td">ÖTK</td>
<td class="td">Ökumenischer Taschenbuch-Kommentar</td>
</tr>
<tr>
<td class="td"><i>PSB</i></td>
<td class="td"><i>Princeton Seminary Bulletin</i></td>
</tr>
<tr>
<td class="td">PTS</td>
<td class="td">Patristische Texte und Studien</td>
</tr>
<tr>
<td class="td">PTSDSSP</td>
<td class="td">Princeton Theological Seminary Dead Sea Scrolls Project</td>
</tr>
<tr>
<td class="td">PVTG</td>
<td class="td">Pseudepigrapha Veteris Testamenti Graece</td>
</tr>
<tr>
<td class="td"><i>PzB</i></td>
<td class="td"><i>Protokolle zur Bibel</i></td>
</tr>
<tr>
<td class="td">QD</td>
<td class="td">Quaestiones Disputatae</td>
</tr>
<tr>
<td class="td"><i>R&amp;T</i></td>
<td class="td"><i>Religion &amp; Theology</i></td>
</tr>
<tr>
<td class="td"><i>RB</i></td>
<td class="td"><i>Revue biblique</i></td>
</tr>
<tr>
<td class="td"><i>RBL</i></td>
<td class="td"><i>Review of Biblical Literature</i></td>
</tr>
<tr>
<td class="td">RBS</td>
<td class="td">Resources for Biblical Study</td>
</tr>
<tr>
<td class="td">RelArts</td>
<td class="td">Religion and the Arts</td>
</tr>
<tr>
<td class="td"><i><a id="page_xxiv">ResQ</a></i></td>
<td class="td"><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td class="td"><i>RevExp</i></td>
<td class="td"><i>Review and Expositor</i></td>
</tr>
<tr>
<td class="td"><i>RGG</i></td>
<td class="td"><i>Religion in Geschichte und Gegenwart.</i> Edited by Hans Dieter Betz. 4th ed. Tübingen: Mohr Siebeck, 1998–2007</td>
</tr>
<tr>
<td class="td">RNT</td>
<td class="td">Regensburger Neues Testament</td>
</tr>
<tr>
<td class="td">SBAB</td>
<td class="td">Stuttgarter biblische Aufsatzbände</td>
</tr>
<tr>
<td class="td">SBB</td>
<td class="td">Stuttgarter biblische Beiträge</td>
</tr>
<tr>
<td class="td">SBLSBS</td>
<td class="td">Society of Biblical Literature Sources for Biblical Study</td>
</tr>
<tr>
<td class="td">SBLSP</td>
<td class="td">Society of Biblical Literature Seminar Papers</td>
</tr>
<tr>
<td class="td">SBS</td>
<td class="td">Stuttgarter Bibelstudien</td>
</tr>
<tr>
<td class="td">SC</td>
<td class="td">Sources chrétiennes</td>
</tr>
<tr>
<td class="td"><i>SEÅ</i></td>
<td class="td"><i>Svensk exegetisk årsbok</i></td>
</tr>
<tr>
<td class="td"><i>SémBib</i></td>
<td class="td"><i>Sémiotique et Bible</i></td>
</tr>
<tr>
<td class="td">SemSt</td>
<td class="td">Semeia Studies</td>
</tr>
<tr>
<td class="td">SKKNT</td>
<td class="td">Stuttgarter kleiner Kommentar, Neues Testament</td>
</tr>
<tr>
<td class="td">SNT</td>
<td class="td">Studien zum Neuen Testament</td>
</tr>
<tr>
<td class="td">SNTS</td>
<td class="td">Studiorum Novi Testamenti Societas</td>
</tr>
<tr>
<td class="td">SNTSU</td>
<td class="td">Studium zum Neuen Testament und seiner Umwelt</td>
</tr>
<tr>
<td class="td">SP</td>
<td class="td">Sacra pagina</td>
</tr>
<tr>
<td class="td"><i>STRev</i></td>
<td class="td"><i>Sewanee Theological Review</i></td>
</tr>
<tr>
<td class="td">SUNT</td>
<td class="td">Studien zur Umwelt des Neuen Testaments</td>
</tr>
<tr>
<td class="td">SVTP</td>
<td class="td">Studia in Veteris Testamenti Pseudepigraphica</td>
</tr>
<tr>
<td class="td"><i>T&amp;K</i></td>
<td class="td"><i>Texte &amp; Kontexte</i></td>
</tr>
<tr>
<td class="td">TANZ</td>
<td class="td">Texte und Arbeiten zum neutestamentlichen Zeitalter</td>
</tr>
<tr>
<td class="td">TB</td>
<td class="td">Theologische Bücherei: Neudrucke und Berichte aus dem 20. Jahrhundert</td>
</tr>
<tr>
<td class="td"><i>TBei</i></td>
<td class="td"><i>Theologische Beiträge</i></td>
</tr>
<tr>
<td class="td"><i>TBT</i></td>
<td class="td"><i>The Bible Today</i></td>
</tr>
<tr>
<td class="td"><i>Them</i></td>
<td class="td"><i>Themelios</i></td>
</tr>
<tr>
<td class="td">THKNT</td>
<td class="td">Theologische Handkommentar zum Neuen Testament</td>
</tr>
<tr>
<td class="td"><i>ThZ</i></td>
<td class="td"><i>Theologische Zeitschrift</i></td>
</tr>
<tr>
<td class="td"><i>TP</i></td>
<td class="td"><i>Theologie und Philosophie</i></td>
</tr>
<tr>
<td class="td"><i>TQ</i></td>
<td class="td"><i>Theologische Quartalschrift</i></td>
</tr>
<tr>
<td class="td"><i>TRE</i></td>
<td class="td"><i>Theologische Realenzyklopädie</i></td>
</tr>
<tr>
<td class="td"><i>TRev</i></td>
<td class="td"><i>Theologische Revue</i></td>
</tr>
<tr>
<td class="td"><i>TRu</i></td>
<td class="td"><i>Theologische Rundschau</i></td>
</tr>
<tr>
<td class="td"><i>TTZ</i></td>
<td class="td"><i>Trierer theologische Zeitschrift</i></td>
</tr>
<tr>
<td class="td">TU</td>
<td class="td">Texte und Untersuchungen</td>
</tr>
<tr>
<td class="td">TVZ</td>
<td class="td">Theologische Verlag Zurich</td>
</tr>
<tr>
<td class="td"><i>TynBul</i></td>
<td class="td"><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td class="td"><a id="page_xxv">VapS</a></td>
<td class="td">Verlautbarungen des Apostolischen Stuhls</td>
</tr>
<tr>
<td class="td"><i>VF</i></td>
<td class="td"><i>Verkündigung und Forschung</i></td>
</tr>
<tr>
<td class="td"><i>VJTR</i></td>
<td class="td"><i>Vidyajyoti Journal of Theological Research</i></td>
</tr>
<tr>
<td class="td">VTSup</td>
<td class="td">Supplements to Vetus Testamentum</td>
</tr>
<tr>
<td class="td">VWGTh</td>
<td class="td">Veröffentlichungen der Wissenschaftlichen Gesellschaft für Theologie</td>
</tr>
<tr>
<td class="td">WBC</td>
<td class="td">Word Biblical Commentary</td>
</tr>
<tr>
<td class="td">WdF</td>
<td class="td">Wege der Forschung</td>
</tr>
<tr>
<td class="td">WMANT</td>
<td class="td">Wissenschaftliche Monographien zum Alten und Neuen Testament</td>
</tr>
<tr>
<td class="td">WUNT</td>
<td class="td">Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td class="td">WVT</td>
<td class="td">Wissenschaftlicher Verlag Trier</td>
</tr>
<tr>
<td class="td"><i>ZDPV</i></td>
<td class="td"><i>Zeitschrift des deutschen Palästina-Vereins</i></td>
</tr>
<tr>
<td class="td"><i>ZKT</i></td>
<td class="td"><i>Zeitschrift für katholische Theologie</i></td>
</tr>
<tr>
<td class="td"><i>ZNT</i></td>
<td class="td"><i>Zeitschrift für Neues Testament</i></td>
</tr>
<tr>
<td class="td"><i>ZNW</i></td>
<td class="td"><i>Zeitschrift für die Neutestamentliche Wissenschaft und die Kunde der älteren Kirche</i></td>
</tr>
<tr>
<td class="td"><i>ZTK</i></td>
<td class="td"><i>Zeitschrift für Theologie und Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?0646ab24